import { render, staticRenderFns } from "./MyTrades.vue?vue&type=template&id=46438b38&scoped=true&"
import script from "./MyTrades.vue?vue&type=script&lang=js&"
export * from "./MyTrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46438b38",
  null
  
)

export default component.exports